module.exports = __webpack_public_path__ + "img/spring_printed_dress-120x156.79189959.jpg";